<div [style.display]="loading ? 'block' : 'none'">
  <div class="text-center">
    <div class="fa-3x">
      <i class="fas fa-spinner fa-spin"></i>
    </div>
  </div>
</div>
